import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import ClientProfileForm from '../../components/ClientProfileForm'
import Spinner from '../../components/Spinner'
import { api } from '../../api'

export default function RegisterClient() {
  const navigate = useNavigate()
  const location = useLocation()
  const [checking, setChecking] = React.useState(true)
  const params = new URLSearchParams(location.search)
  const next = params.get('next') || ''

  React.useEffect(() => {
    (async () => {
      try {
        const me = await api.me()
        if (me && me.needsRegistration === false) {
          const target = next && next.startsWith('/') ? next : '/account'
          navigate(target, { replace: true })
          return
        }
      } catch {
        // ignore and allow form to render
      } finally {
        setChecking(false)
      }
    })()
  }, [navigate])

  if (checking) {
    return (
      <div className="container page-wide register-client-page" style={{ textAlign: 'center', paddingTop: '3rem' }}>
        <Spinner label="Loading…" />
      </div>
    )
  }

  return (
    <div className="container page-wide register-client-page">
      <div className="page-head">
        <div>
          <p className="hero-kicker">Clients</p>
          <h1>Your contact details</h1>
          <p className="hint">So the professional can get back to you.</p>
        </div>
      </div>

      <div className="card form-card">
        <ClientProfileForm
          mode="create"
          onSuccess={() => {
            const target = next && next.startsWith('/') ? next : '/clients'
            window.location.assign(target)
          }}
        />
      </div>
    </div>
  )
}
